import { Link } from "react-router-dom";
import { CITIES } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#07131f] text-slate-400 py-16 border-t border-slate-800 text-sm" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-4">
            <div className="inline-block bg-white rounded-xl px-5 py-3">
              <img
                src="/assets/whitestone-logo-full.png"
                alt="Whitestone — Premium Water. Peace of Mind."
                className="h-14 w-auto"
              />
            </div>
            <p className="mt-4 text-xs text-slate-400 leading-relaxed max-w-sm">
              Whitestone provides comprehensive residential water analysis, softening, and whole-home
              filtration guidance throughout Oklahoma. We help you understand your water first — then
              decide what, if anything, your home needs.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white mb-3">Explore</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/#curiosity" className="hover:text-white transition" data-testid="footer-link-curiosity">What's In Water</Link></li>
              <li><Link to="/#oklahoma" className="hover:text-white transition" data-testid="footer-link-oklahoma">Oklahoma Water</Link></li>
              <li><Link to="/#test" className="hover:text-white transition" data-testid="footer-link-test">What We Test</Link></li>
              <li><Link to="/#softener-vs-filter" className="hover:text-white transition" data-testid="footer-link-softener">Softener vs Filter</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white mb-3">Information</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/#pricing" className="hover:text-white transition" data-testid="footer-link-pricing">Cost Transparency</Link></li>
              <li><Link to="/#faq" className="hover:text-white transition" data-testid="footer-link-faq">Homeowner FAQ</Link></li>
              <li><Link to="/#contact" className="hover:text-white transition" data-testid="footer-link-contact">Free Analysis</Link></li>
              <li><Link to="/locations" className="hover:text-white transition" data-testid="footer-link-locations">Service Areas</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white mb-3">Oklahoma Service Areas</h4>
            <p className="text-xs text-slate-400 leading-relaxed">
              {CITIES.map((c) => c.name).join(", ")}, and surrounding communities.
            </p>
            <div className="mt-4 pt-4 border-t border-slate-800 text-xs text-slate-400 space-y-1">
              <p>Phone: <a href="tel:+18555915274" className="text-white hover:text-sky-300 transition" data-testid="footer-phone-link">855-591-5274</a></p>
            </div>
            <Link to="/#contact" data-testid="footer-cta-button"
              className="mt-6 inline-flex items-center justify-center px-6 py-3 rounded-xl text-sm font-bold text-slate-950 bg-sky-300 hover:bg-sky-200 transition shadow-lg">
              GET MY FREE WATER ANALYSIS
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-400 gap-4">
          <p>Whitestone Residential Water Conditioning. All rights reserved.</p>
          <p className="text-slate-400">Premium Water. Peace of Mind.</p>
        </div>
      </div>
    </footer>
  );
}
